import { render, staticRenderFns } from "./ViewPointList.vue?vue&type=template&id=3a5978dc&scoped=true"
import script from "./ViewPointList.vue?vue&type=script&lang=js"
export * from "./ViewPointList.vue?vue&type=script&lang=js"
import style0 from "./ViewPointList.vue?vue&type=style&index=0&id=3a5978dc&prod&lang=scss&scoped=true"
import style1 from "./ViewPointList.vue?vue&type=style&index=1&id=3a5978dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5978dc",
  null
  
)

export default component.exports